import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { MiGridSelectionComponent } from 'app/modules/shared/components/mi-grid-selection/mi-grid-selection.component';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-add-manage-shift-planning',
  templateUrl: './add-manage-shift-planning.component.html',
  styleUrls: ['./add-manage-shift-planning.component.scss']
})
export class AddManageShiftPlanningComponent implements OnInit {
  endsOnTableList = AppSettings.SHIFT_PLANNING_ENDSON_TABLELIST;
  endsOnFilterTableList = AppSettings.SHIFT_PLANNING_ENDSON_FILTERLIST;
  @Input() selectedAddDataEmmiter: any;

  labelAddShift: any;
  shiftAllData: any = [];
  labelYes: any;
  labelNo: any;
  minDate: Date;
  maxDate: Date;
  dateFormat;
  teamList: any[] = [];
  formRequiredStatus = false;
  daysList = AppSettings.SHIFT_PLANNING_DAYS_LIST;
  shiftButtonDisabled = false;
  allocationListStr: any;
  shiftStartTime: any;
  shiftEndTime: any;
  teamListIds: any = [];
  startDateTimeStr: any;
  endDateTimeStr: any;
  groupLimit = 100;
  groupOffset = 0;
  totalRecords: any;
  products: any = [];
  minuteArray: number[] = [0, 15, 30, 45];
  currentDate = new Date();
  isEditEnable = false;
  loginTypeList: any;
  loginTypeisWeb = false;
  urlAssign = '';
  gridTheme = 'mi';
  url = '';
  newUrl;
  gridColumn: any[] = [];
  exportUrl = '';
  printUrl = '';
  searchDisplay = true;
  columns: any = [];
  @ViewChild(MiGridSelectionComponent) gridRef: MiGridSelectionComponent;
  totalAndActiveCounts: { label: any; value: any; }[];
  buttons: any[] = [];
  params: any = '';
  selectedData: any;
  weeklyAllocationData: string;
  teamNames: string;
  teamName: any;
  endTimeStr: any;
  startTimeStr: any;
  endDateTime: string;
  selectedScheduleId: string;
  teamChecked: any[] = [];
  userType: any;
  shiftSchedule;
  selectedProviderId: string;
  startDateTimes: string;
  allTeamChecked: any[] = [];
  bulckScheduleId: any[];
  bulckScheduleChecked = false;
  endDateTimeS: any;
  endDateTimeSe: any;
  teamNamesa: string;
  isChecked = true;
  maxDays = '10';
  shiftPlanUsers: any;
  showDialog = false;
  labelOverride = 'Override';
  labelAdjust = 'Adjust';
  labelCancel = 'Cancel';
  labelSave = 'Save';
  selectedRowdata: any;
  updateType: any;
  startEndTimeValidationStatus = true;
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private router: Router,
    private uiService: UiService,
    private storageService: StorageService,
    private commonService: CommonBindingDataService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.maxDays = this.commonService.getTenantConfigValue(AppSettings.EDIT_TEAM_LIST_MAX_DATE);
    this.selectedData = sessionStorage.getItem('selectedAddData');
    this.weeklyAllocationData = JSON.parse(sessionStorage.getItem('weeklyAllocation'));
    this.shiftPlanUsers = JSON.parse(sessionStorage.getItem('shiftPlanUsers'));
    this.selectedScheduleId = sessionStorage.getItem('selectedScheduleId');
    this.teamNames = sessionStorage.getItem('teamNames');
    this.endTimeStr = sessionStorage.getItem('endTimeStr');
    this.startTimeStr = sessionStorage.getItem('startTimeStr');
    this.endDateTime = sessionStorage.getItem('endDateTimeStr');
    this.endDateTimeS = sessionStorage.getItem('startDateTimeStr');
    this.endDateTimeSe = sessionStorage.getItem('endDateTimeStr');
    this.userType = sessionStorage.getItem('userType');
    this.shiftSchedule = sessionStorage.getItem('shiftSchedule');

    this.selectedProviderId = sessionStorage.getItem('selectedProviderId');
    this.teamNamesa = this.teamNames !== 'null' || undefined ? this.teamNames : '--';
    if (this.endDateTime === 'Never' || this.endDateTime === '-1') {
      this.endDateTimeStr = this.endDateTime = 'never';
      this.endDateTimeS = this.endDateTimeS;
      this.endDateTimeSe = '';

    } else {
      this.endDateTimeStr = this.endDateTime = 'custom';
      this.endDateTimeS = this.endDateTimeS;
      this.endDateTimeSe = this.endDateTimeSe;
    }

    this.startDateTimes = sessionStorage.getItem('startDateTimeStr');
    if (this.userType === '10') {
      this.url = '/secure/schedule/bulk/users'
        + '?teamIds=' + this.selectedData
        + '&providerId=' + this.selectedProviderId
        + '&scheduleId=' + this.selectedScheduleId
        + '&userType=' + this.userType;
    }
    if (this.userType !== '10') {
      this.url = '/secure/schedule/bulk/users' + '?scheduleId=' + this.selectedScheduleId + '&userType=' + this.userType;
    }
    this.openShiftGrid();
    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    if (tagsData === null) {
      const localTagData = localStorage.getItem('localTagdata');
      this.getLoginTypes(JSON.parse(localTagData));
    } else {
      this.getLoginTypes(tagsData);
    }
    this.getLabelAndDate();
    this.getShiftData();
    this.getTeam();
    this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();
  }

  openShiftGrid() {
    this.columns.push({
      field: 'firstName', sortId: 'firstName', header: this.commonBindingDataService.getLabel('user Name'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.colFullName(i))
    });
    this.columns.push({
      field: 'email', sortId: 'email', header: this.commonBindingDataService.getLabel('label_email'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.setEmail(i.email))
    });
    if (this.userType === '10') {
      this.columns.push({
        field: 'teamName', sortId: 'teamName', header: this.commonBindingDataService.getLabel('Team Name'),
        sort: false, resize: true,
      });
    }
    this.columns.push({
      field: 'shiftSchedule', sortId: 'shiftSchedule', header: this.commonBindingDataService.getLabel('shift plan'),
      sort: false, resize: true,
    });
  }

  goBack() {
    // this.location.back(); // <-- go back to previous location
    this.router.navigate(['manage-shift/shift-planning']);
  }

  checkboxClicked(event) {
    this.teamChecked = event;
    if (this.teamChecked.length > 0) {
      this.bulckScheduleChecked = true;
    } else {
      this.bulckScheduleChecked = false;

    }
  }

  allTasksEvent(event) {
    this.allTeamChecked = event;
  }

  selectAllData(event) {
    if (event === true) {
      this.teamChecked = this.allTeamChecked;
      if (this.teamChecked) {
        this.bulckScheduleChecked = true;
      }
    } else {
      this.bulckScheduleChecked = false;

    }
  }

  colFullName(params) {
    let lblActivate = '';
    let lastName = '';
    let permanentSchedule;
    if (params.lastName !== null && params.lastName !== 'null') {
      lastName = params.lastName;
    }
    permanentSchedule = params.permanentSchedule ? '*' : '';
    if (params.firstName) {
      if (params.numCountryCode !== undefined && params.numCountryCode !== null) {
        lblActivate = `<div title="` + permanentSchedule + params.firstName + ' ' + lastName + `">` + permanentSchedule + params.firstName + ' ' + lastName + '';
      } else {
        lblActivate = `<div title="` + permanentSchedule + params.firstName + ' ' + lastName + `">` + permanentSchedule + params.firstName + ' ' + lastName + '';
      }
    }
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-comman-col');
    eDiv.innerHTML = lblActivate;
    return eDiv;
  }

  setEmail(params) {
    let email = '';
    if (params) {
      email = `<div title="` + params + `">` + params +
        `</div>`;
    } else {
      email = `<div title=""> -- </div>`;
    }

    const eDiv = document.createElement('div');
    eDiv.innerHTML += email;
    return eDiv;
  }

  getDate(params) {
    const tripTime = params.appliedOnStr;
    const date = this.commonBindingDataService.toTimezoneDateTimeStringFormatStr(params.appliedOnStr, params.timezoneAbbr);
    const time = this.commonBindingDataService.toTimezoneTimeFormatWithout(params.appliedOnStr, params.timezoneAbbr);

    let tripDateTime = '';
    if (tripTime !== null && tripTime !== 0) {
      tripDateTime = `<div title="` + date + `">` + date + `</div><div title="` + time + `">` + `</div>`;
    } else {
      tripDateTime = `<div title="">--</div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML += tripDateTime;
    return eDiv;
  }

  getLabelAndDate() {
    this.labelYes = this.commonBindingDataService.getLabel('label_yes');
    this.labelNo = this.commonBindingDataService.getLabel('label_no_without_dot');
    this.labelAddShift = this.commonBindingDataService.getLabel('label_add_new_shift');
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.minDate = new Date();
    this.maxDate = new Date();
  }

  getShiftData() {
    this.manageOpenShiftsService.getShiftPlanningData(this.groupLimit, this.groupOffset).subscribe(results => {
      this.totalRecords = results.count;
      // this.shiftAllData = [...this.shiftAllData, ...results.data];
      this.groupLimit = results.count;
      this.shiftAllData = results.data;
      this.products = results.data;
      for (let i = 0; i < this.shiftAllData.length; i++) {
        const text = this.shiftAllData[i].allocations;
        Object.assign(this.shiftAllData[i], {
          'weeklyAllocation': [
            { key: '1', displayValue: 'S', isMandatory: text.includes('1') },
            { key: '2', displayValue: 'M', isMandatory: text.includes('2') },
            { key: '3', displayValue: 'T', isMandatory: text.includes('3') },
            { key: '4', displayValue: 'W', isMandatory: text.includes('4') },
            { key: '5', displayValue: 'T', isMandatory: text.includes('5') },
            { key: '6', displayValue: 'F', isMandatory: text.includes('6') },
            { key: '7', displayValue: 'S', isMandatory: text.includes('7') }
          ]
        }, );
        const teamListAllId = [];
        for (let j = 0; j < this.shiftAllData[i].teamList.length; j++) {
          teamListAllId.push(this.shiftAllData[i].teamList[j].teamId);
        }
        // const teamListAllId = this.shiftAllData[i].teamList[0].teamId;
        Object.assign(this.shiftAllData[i], { 'selectedTeamList': teamListAllId });
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  newRow() {
    return {
      weeklyAllocation: [
        { key: '1', displayValue: 'S', isMandatory: false },
        { key: '2', displayValue: 'M', isMandatory: false },
        { key: '3', displayValue: 'T', isMandatory: false },
        { key: '4', displayValue: 'W', isMandatory: false },
        { key: '5', displayValue: 'T', isMandatory: false },
        { key: '6', displayValue: 'F', isMandatory: false },
        { key: '7', displayValue: 'S', isMandatory: false }
      ],
      spPermenantMembers: [], shiftSchedule: '', startTimeStr: '', endTimeStr: '', endDate: '', teamList: ''
    };
  }

  validateForm() {
   this.shiftStartTime = this.shiftStartTime ? this.shiftStartTime
     : (this.startTimeStr.toString().includes('M') ? this.startTimeStr
       : moment(new Date(this.startTimeStr)).format('hh:mm A'));
   this.shiftEndTime = this.shiftEndTime ? this.shiftEndTime
     : (this.endTimeStr.toString().includes('M') ? this.endTimeStr
       : moment(new Date(this.endTimeStr)).format('hh:mm A'));
    const d = new Date();
    const dateValue = moment(d).format('MM/DD/YYYY');
    const startValue = new Date(dateValue + ' ' + this.shiftStartTime);
    const endValue = new Date(dateValue + ' ' + this.shiftEndTime);
    const startTimeMillis = startValue.getTime();
    const endTimeMillis = endValue.getTime();
    if (startTimeMillis === endTimeMillis) {
       this.startEndTimeValidationStatus = false;
       this.uiService.showMessage('End time should be greater than Start time', AppSettings.MESSAGE_TYPES.ERROR);
    } else {
      this.startEndTimeValidationStatus = true;
    }
  }

  saveBulk() {

    const dataModel = this.getFormData();
      this.manageOpenShiftsService.addScheduleBulk(dataModel).subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.router.navigate(['manage-shift/shift-planning']);
      }, (error) => {
        if (this.endDateTimeStr === -1) {
          this.endDateTimeStr = this.endDateTimeStr === -1 ? 'never' : this.endDateTimeStr;
        } else {
          this.endDateTimeStr = 'custom';
        }
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });

  }

  onBulkScheduleSave(selectedRowData) {
    this.selectedRowdata = selectedRowData;
    this.setFormData(this.selectedRowdata);
    this.validateForm();
    if (this.startEndTimeValidationStatus) {
      this.showDialog = true;
    }
  /*this.confirmationService.confirm({
    message: "Are you sure you want update existing schedule?",
      accept: () => {
        this.setFormData(selectedRowData);
        const dataModel = this.getFormData();
        this.manageOpenShiftsService.addScheduleBulk(dataModel).subscribe(results => {
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.router.navigate(['manage-shift/shift-planning']);
        }, (error) => {
          if (this.endDateTimeStr === -1) {
            this.endDateTimeStr = this.endDateTimeStr === -1 ? 'never' : this.endDateTimeStr;
          } else {
            this.endDateTimeS = this.endDateTimeStr;
            this.endDateTimeStr = 'custom'
          }
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
    }});*/
  }

  onStartDateClick(itemsData) {
    if (itemsData) {
      const formattedStartDate = moment(itemsData).format('MM/DD/YYYY') + ' 12:00 AM';
      this.maxDate = moment(formattedStartDate, 'MM/DD/YYYY hh:mm A').toDate();
    }
  }

  getTeam() {
    this.manageOpenShiftsService.getTeam().subscribe((result) => {
      this.teamList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
      for (let i = 0; i < result.length; i++) {
        this.teamList.push({ label: result[i].teamName, value: result[i].id });
      }
    }, () => {
    });
  }

  addShiftBtn() {
    this.isEditEnable = true;
    this.shiftButtonDisabled = true;
  }

  setFormData(selectedRowData) {
    this.shiftButtonDisabled = false;
    let allocationList = '';
    for (let k = 0; k < this.weeklyAllocationData.length; k++) {
      if (selectedRowData[k].isMandatory === true) {
        allocationList += selectedRowData[k].key + ',';
      }
    }
    this.allocationListStr = allocationList.replace(/,\s*$/, '');
    if (this.startTimeStr.length > 8 || this.startTimeStr.length === undefined) {
      this.shiftStartTime = moment(this.startTimeStr).format('hh:mm A');
    } else {
      this.shiftStartTime = selectedRowData.startTimeStr;
    }
    if (this.endTimeStr.length > 8 || this.endTimeStr.length === undefined) {
      this.shiftEndTime = moment(this.endTimeStr).format('hh:mm A');
    } else {
      this.shiftEndTime = selectedRowData.endTimeStr;
    }
    const startDate = new Date();
    this.startDateTimeStr = moment(this.endDateTimeS).format('MM/DD/YYYY') + ' ' + '12:00 AM';
    if (this.endDateTimeStr === 'custom') {
      this.endDateTimeStr = moment(this.endDateTimeSe).format('MM/DD/YYYY') + ' ' + '11:59 PM';
    } else {
      this.endDateTimeStr = -1;
    }
    if (this.endDateTimeStr === 'Never' || this.endDateTimeStr === -1) {
      this.endDateTimeStr = this.endDateTime = 'never';
      this.endDateTimeS = '';
      this.endDateTimeSe = '';

    } else {
      this.endDateTimeStr = this.endDateTime = 'custom';
      this.endDateTimeS = this.endDateTimeS;
      this.endDateTimeSe = this.endDateTimeSe;
    }
  }

  getFormData() {
    this.bulckScheduleId = [];
    if (this.teamChecked) {
      for (let k = 0; k < this.teamChecked.length; k++) {
        this.bulckScheduleId.push({
          'userId': this.teamChecked[k].id
        });
      }
    }

    const requestFormModel: any = {
      'startTimeStr': this.shiftStartTime ? this.shiftStartTime
        : (this.startTimeStr.toString().includes('M') ? this.startTimeStr
          : moment(new Date(this.startTimeStr)).format('hh:mm A')),
      'endTimeStr': this.shiftEndTime ? this.shiftEndTime
        : (this.endTimeStr.toString().includes('M') ? this.endTimeStr
          : moment(new Date(this.endTimeStr)).format('hh:mm A')),
      'startDateTimeStr': this.startDateTimeStr,
      'endDateTimeStr':  this.endDateTimeStr === 'never' ? -1 : moment(this.endDateTimeSe).format('MM/DD/YYYY') + ' ' + '11:59 PM',
      'allocations': this.allocationListStr,
      'memberList': this.bulckScheduleId,
      'updateType': this.updateType,
      'webShiftPlanUpdate': true,
      'shiftPlanId': this.selectedScheduleId,
      'teamId': 0,
      'shiftSchedule': this.shiftSchedule
    };
    return requestFormModel;
  }


  getTime(date: any) {
    if (date !== '') {
      const hour = moment(date).format('hh:mm A').split(':');
      const time = this.commonBindingDataService.timeAdjustment(hour);
      this.startTimeStr = moment(new Date(`1970-01-01 ${time}`)).format('hh:mm A');

    }

  }

  getEndTime(date: any) {
    if (date !== '') {
      const hour1 = moment(date).format('hh:mm A');
      const hour = moment(date).format('hh:mm A').split(':');
      if (hour1 !== '11:59 PM') {
        const time = this.commonBindingDataService.timeAdjustment(hour);
        this.endTimeStr = moment(new Date(`1970-01-01 ${time}`)).format('hh:mm A');
      }

    }
  }
  getLoginTypes(tagsData: any) {
    this.loginTypeList = [];
    this.loginTypeList.push({ label: this.commonService.getLabel('Select'), value: '' });
    tagsData.login_type.forEach(element => {
      this.loginTypeList.push({ label: element.tagValue, value: element.id });
    });
  }

  loginType(event) {
    this.loginTypeisWeb = event.value === '20' ? true : false;
  }

  cancelBut() {
    this.router.navigate(['manage-shift/shift-planning']);
  }

  allocationListData(event) {
    let allocationList = '';
    for (let k = 0; k < this.weeklyAllocationData.length; k++) {
      if (event[k].isMandatory === true) {
        allocationList += event[k].key + ',';
      }
    }
    this.allocationListStr = allocationList.replace(/,\s*$/, '');
    if (this.allocationListStr === '') {
      this.isChecked = false;
    } else {
      this.isChecked = true;
    }

  }

  onHideDialog() {
    this.showDialog = false;
  }
  setAdjustValue() {
    this.updateType = 10;
    this.saveBulk();

  }

  setOverrideValue() {
    this.updateType = 20;
    this.saveBulk();
  }
}

